import { renderEUDateTimeLong } from "../../utils/utils";
import { Link } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import { EditableInputDisplay } from "../../components/EditableComponents";

const getColumns = (setEditMode, setParentValue) => {
  return [
    {
      size: 180,
      muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
      enableColumnFilter: true,
      filterFn: "contains",
      accessorFn: (row) => `${row.patient_info}`,
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Paziente",
    },
    {
      size: 180,
      muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
      enableColumnFilter: true,
      filterFn: "contains",
      accessorFn: (row) => `${row.doctor_info}`,
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Professionista Sanitario",
    },
    {
      size: 180,
      enableColumnFilter: false,
      header: "Data/ora",
      Cell: ({ cell, row }) => (
        <EditableInputDisplay
          label={null}
          id={"date"}
          setEditMode={setEditMode}
          initialValue={row.original.date}
          inputMode={"datetime"}
          setParentValue={setParentValue}
        />
      ),
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    },
    {
      size: 50,
      enableColumnFilter: false,
      accessorFn: (row) => (
        <Link target="_blank" href={row.link}>
          Collegati
        </Link>
      ),
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Link",
    },
    {
      size: 5,
      accessorKey: "is_done",
      enableColumnFilter: false, // TODO
      muiTableHeadCellFilterTextFieldProps: {
        placeholder: "Da fare/completata",
      },
      accessorFn: (row) => (row.is_active ? "true" : "false"),
      filterVariant: "checkbox",
      Cell: ({ cell }) =>
        cell.getValue() === "true" ? (
          <DoneIcon color="success" />
        ) : (
          <CloseIcon color="error" />
        ),
      muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
      header: "Attivo",
    },
  ];
};

export default getColumns;
